export class SendSurveyWidgetSettings {
  public surveyUrl: string;
}
